import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './BlogPost.css';

const BlogPost = ({ blogs }) => {
  const { slug } = useParams();
  const blog = blogs.find(b => b.slug === slug);
  if (!blog) return <h2 style={{ padding: 30 }}>404 - Blog not found</h2>;

  return (
    <div className="blog-post">
      <Link to="/blogs" className="back-link">← Back to Blog</Link>
      <h1 style={{ color: '#FF0000' }}>{blog.title}</h1>
      <p><i>{blog.date}</i> • <span className="category">{blog.category}</span></p>
      {blog.coverImage && <img src={blog.coverImage} alt={blog.title} />}
      <div dangerouslySetInnerHTML={{ __html: blog.content }} />
      {blog.backlink && <a href={blog.backlink} target="_blank" className="backlink-btn">Visit Backlink</a>}
    </div>
  );
};

export default BlogPost;
